export default __webpack_public_path__ + "static/media/AERO40ARRAY.84c3c4e0.png";